import React, {useEffect} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../data/types/interface/api';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {Loader} from '../../components/Loader';
import {ProduitItem} from '../../components/ProduitItem';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function CatalogueScreen(props: any) {
  const {getCategoriecatalogue, getCategoriedemarche} = props;
  const {data} = props.route.params;

  const [dataList, setData] = React.useState([]);
  const [isCatalogue, checkCatalogue] = React.useState(true);
  const [isLoading, setLoading] = React.useState(true);
  const [refreshing, setRefreshing] = React.useState(false);

  useEffect(() => {
    switch (data) {
      case 'Catalogue de produit': {
        getListCatalogue();
        break;
      }
      case 'Les démarches': {
        getListDemarche();
        break;
      }
      default: {
        break;
      }
    }
  }, []);

  const getListCatalogue = () => {
    getCategoriecatalogue({}, (res: ApiResponse) => {
      if (res && res.data && res.data.items) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        res.data.items.sort(function (a: any, b: any) {
          return a.ordre - b.ordre;
        });
        setData(() => res.data);
        setLoading(false);
      }
    });
  };

  const getListDemarche = () => {
    getCategoriedemarche({}, (res: ApiResponse) => {
      if (res && res.data) {
        checkCatalogue(false);
        setData(res.data);
        setLoading(false);
      }
    });
  };

  const onRefresh = React.useCallback(() => {
    setRefreshing(true);
    switch (data) {
      case 'Catalogue de produit': {
        getListCatalogue();
        break;
      }
      case 'Les démarches': {
        getListDemarche();
        break;
      }
    }
    setRefreshing(false);
  }, []);

  return (
    <View style={{flex: 1}}>
      <HeaderScreen title={data} type="home" noBreadcrumb={false} />
      {isLoading ? (
        <Loader />
      ) : (
        <ProduitItem
          data={dataList}
          isCatalogue={isCatalogue}
          titleParent={data}
          refreshing={refreshing}
          refreshList={onRefresh}
        />
      )}
    </View>
  );
}

export const CatalogueProduit = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CatalogueScreen);
